import { Provider } from "@angular/core";
import { ClaimSearchService } from "./cliam-search.service";
import { SaveEventService } from "./save-event.service";
import { QuotePolicySearchService } from "./quote-policy-search.service";
import { EcoMasterData } from "./eco-master.service";
import { EcoAgencyAgent } from "./eco-agency-agent.service";
import { CopyQuoteService } from "./copy-quote.service";
import { IssueNewBusinessService } from "./issue-new-business.service";
import { FormsECOService } from "./formsECO.service";
import { PolicyMasterDataService } from "./policy-master.service";
import { KnrPolicyQuoteService } from "libs/data-service/kidnap-ransom/knr-policy-quote.service";

// services
export * from "./cliam-search.service";
export * from "./quote-policy-search.service";
export * from "./smarty-street-sdk.service";
export * from "./eco-master.service";
export * from "./eco-master.service";
export * from "./quote-create-bussiness.service";
export * from "./eco-agency-agent.service";
export * from "./save-event.service";
export * from "./quote-step.service";
export * from "./copy-quote.service";
export * from "./subjectivity.service";
export * from "./form-validation.service";
export * from "./issue-new-business.service";
export * from "./formsECO.service";
export * from "./policy-master.service";
export * from "./download-quote.service";
export * from "./kidnap-ransom/knr-policy-quote.service";

// definitions
// export * from './def/get-dashboard';
export {ClaimSearchRequest, ClaimSearchResponse, ClaimSearchResult} from "./def/claim-search";
export {PolicySearchRequest,PolicySearchResponse,PolicySearchResult} from "./def/policy-search";
export * from "./def/quote-policy-search";
export {EcoSearchRequest, EcoSearchResponse, EcoSearchResult} from "./def/eco-dashboard-search";
export * from "./def/quote-general.def";
export {
  Addresses,
  ClaimHandler,
  ContactElementUpdateRequests,
  ContactRequest,
  ContactResponse,
  EcoAgencyRequest,
  EcoAgencyResponse,
  UpdateUserConfigurableDataElement
} from "./def/eco-agency-agent";
export {
  Coverage,
  CreateActivityLogItem,
  ElementUpdateRequest,
  Risk,
  RiskDataElements,
  SaveEventRequest,
  SaveEventResponse,
  UpdateEventDetails,
  UpdateUserConfigurableDataElements,
  policyDataElements
} from "./def/events";
export {
  AdditionalSummaries,
  Coverages,
  CreateActivityLogItemObj,
  ElementUpdateRequests,
  LOBRiskDataElements,
  LOBRisks,
  LOBs,
  PolicyContacts,
  PolicyMovement,
  PolicyTxnRequest,
  PolicyTxnResponse,
  ProducerCommissions,
  QuoteOptions,
  UWQuotaShares,
  UWQuotes
} from "./def/quote-policy-step";
export {CopyQuoteRequest, CopyQuoteResponse, CopyQuoteResponselist} from "./def/copy-quote";
export {
  GetPolicySubjectivitiesRequest,
  PolicySubjectivityResponse,
  SaveMiscellaneousChangesRequest,
  SaveMiscellaneousChangesResponse,
  SaveSubjectiviyRequest,
  Subjectivity,
  SubjectivityRequest
} from "./def/subjectivity";
export {
  UpdateAndDownloadQuoteECO,
  CreateActivityLogItemData,
  PolicyDataElements,
  DownloadQuoteECO
} from "./def/updateAndDownloadQuoteECO";
export {
  EcoMasterRequest,
  EcoMasterResponse,
  Country,
  StateOrProvince,
  Underwriters,
  TermTypes,
  PolicyTypes,
  SubmissionTypes,
  RenewalOptions,
  UnderwriterAssistants,
  PaymentPlans
} from "../data-service/def/eco-master";
export {
  CreateActivityLogItemForNB,
  IssueNewBusinessRequest,
  IssueNewBusinessResponse
} from "./def/issue-new-business";
export {
  AddOptionalEndorsementFormsECO,
  AddOptionalEndorsementResponse,
  ApproveQuoteRequest,
  AvailableForms,
  AvailableFormsResponse,
  CreateActivityLogItems,
  CustomFields,
  ElementUpdateRequestObj,
  EndorsementForms,
  EndorsementFormsResponse,
  EndorsmentFormsRequest,
  OptionalEndorsementForms,
  PolicyDataElement
} from "./def/eco-endorsment-forms";
export {KnrPolicySearchRequest} from "./def/knr-quote-policy-search"
export * from "./def/knrsubjectivity"
export const DataServiceProviders: Provider[] = [
  ClaimSearchService,
  QuotePolicySearchService,
  EcoMasterData,
  EcoAgencyAgent,
  SaveEventService,
  CopyQuoteService,
  IssueNewBusinessService,
  FormsECOService,
  PolicyMasterDataService,  
  KnrPolicyQuoteService
];
